<template>
  <div
    class="fts-input-group-icon"
    :class="[
      { 'input-group-icon--active': active },
      { 'input-group-icon--disabled': disabled },
    ]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
    disabled: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/vars" as *;
@use "./src/assets/scss/colors" as *;

.fts-input-group-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border-radius: $border-radius;
  color: var(--fts-default);
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  > * {
    min-width: $font-size;
    font-size: $font-size;
  }
  &:hover {
    @include theme {
      background-color: rgba(theme-get("fts-gray-100"), 0.75);
    }
  }
  &.input-group-icon--active {
    color: var(--fts-primary);
    &:hover {
      @include theme {
        background-color: rgba(theme-get("fts-primary"), 0.095);
      }
    }
  }
  &.input-group-icon--disabled {
    color: var(--fts-disabled);
    cursor: not-allowed;
    &:hover {
      background-color: transparent;
    }
  }
}
</style>